import { mainSiteUrl } from "@/mocks/kakobuy";

export default function CTASection() {
  return (
    <section className="py-20 md:py-28 bg-background-50">
      <div className="w-full max-w-5xl mx-auto px-4 md:px-6 text-center">
        <div className="relative rounded-2xl overflow-hidden mb-12 mx-auto max-w-3xl h-[200px] md:h-[280px]">
          <img
            src="https://readdy.ai/api/search-image?query=Bright%20inviting%20online%20shopping%20scene%20with%20colorful%20fashion%20items%20floating%20around%20a%20glowing%20digital%20shopping%20cart%20on%20a%20fresh%20lime%20green%20and%20sunshine%20yellow%20gradient%20background%20energetic%20optimistic%20ecommerce%20illustration%20style%20with%20playful%20movement%20and%20sparkle%20effects&width=1200&height=560&seq=cta-collage-v2-2026-jun&orientation=landscape"
            alt="Kakobuy Spreadsheet - najlepsze produkty i okazje zakupowe 2026"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/15 via-transparent to-transparent"></div>
        </div>

        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 leading-snug mb-2">
          Gotowy na{" "}
          <em className="font-heading italic text-foreground-600 font-normal">najlepsze zakupy</em>?
        </h2>
        <p className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 leading-snug mb-2">
          Odkryj{" "}
          <strong className="text-primary-500">kakobuy spreadsheet</strong>
        </p>
        <p className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 leading-snug mb-10">
          i{" "}
          <em className="font-heading italic text-foreground-600 font-normal">zaoszczędź</em>
        </p>

        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 px-10 py-4 bg-foreground-900 text-white font-semibold text-sm rounded-full hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          Przejdź do kaspreadsheet.com
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-up-line text-sm"></i>
          </span>
        </a>

        <p className="text-xs text-foreground-400 mt-6 max-w-md mx-auto">
          Kliknij powyżej, aby odwiedzić naszą główną stronę z pełną listą produktów i najlepszymi okazjami.
        </p>
      </div>
    </section>
  );
}